import { css } from '@emotion/react';

export const container = css({
  width: 1920,
  height: 1080
});

export const contentContainer = css({
  width: 1792,
  height: 952,
  padding: 64
});
